export default __webpack_public_path__ + "static/media/rar.97fc71da.svg";